export const style = {
  Box: {
    sx: {
      my: 1,
    },
  },
  card: {
    title: {
      sx: {
        color: 'action.active',
        pb: 3,
      },
    },
    divider: {
      sx: {
        my: 2,
      },
    },
    row: {
      sx: {
        display: 'flex',
        alignItems: 'center',
        gap: 2,
      },
    },
  },
} as const;
